import { useState } from "react";
// import { fieldNames } from '../../components/PIForm/Steps/step3/utils'
import { fieldNames } from "../../components/ContactInfoChangeForm/steps/step3/utils";

const {
  DIRECTOR_FULL_NAME,
  COUNTRY,
  IDENTIFICATION_NUMBER,
  CITY,
  COUNTRY_CODE,
  LEGAL_FORM,
  CITY_VILLAGE,
  APARTMENT_NUMBER,
  HOME_NUMBER,
  STREET,
  ACTUAL_ADDRESS,
  VILLAGE,
  NAME_OF_COMPANY,
  CONTACT_INFO_CHANGE_CHECKBOXES,
  CONFIRMATION_STATUS,
  LEGAL_ADDRESS,
  IS_ACTUAL_ADDRESS
} = fieldNames;

const initAddress = {
  [COUNTRY]: "",
  [CITY]: "",
  [STREET]: "",
  [CITY_VILLAGE]: "",
  [HOME_NUMBER]: "",
  [APARTMENT_NUMBER]: "",
  [VILLAGE]: "",
};

const initState = {
  [DIRECTOR_FULL_NAME]: "",
  [LEGAL_FORM]: "2",
  [IDENTIFICATION_NUMBER]: "",
  [COUNTRY_CODE]: "",
  [NAME_OF_COMPANY]: "",
  [CONTACT_INFO_CHANGE_CHECKBOXES]: [],
  [IS_ACTUAL_ADDRESS]: false,
  [CONFIRMATION_STATUS]: false,
  [ACTUAL_ADDRESS]: { ...initAddress },
  [LEGAL_ADDRESS]: { ...initAddress },
};

function useStepThreeValues() {
  const [stepThreeValues, setStepThreeValues] = useState(initState);
  return { stepThreeValues, setStepThreeValues };
}

export default useStepThreeValues;
